import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { CATEGORIES } from "@/config/site";

const EMPTY = { name: "", description: "", price: "", category: CATEGORIES[0], image: "", available: true, featured: false };

export const ProductDialog = ({ open, onOpenChange, product, onSave, saving }) => {
  const [f, setF] = useState(EMPTY);

  useEffect(() => {
    if (open) setF(product ? { ...EMPTY, ...product, price: product.price == null ? "" : String(product.price) } : EMPTY);
  }, [open, product]);

  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e?.target ? e.target.value : e }));
  const submit = (e) => {
    e.preventDefault();
    const raw = String(f.price).trim();
    onSave({ ...f, price: raw ? parseFloat(raw.replace(",", ".")) || 0 : null });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-lenis-prevent data-testid="product-dialog" className="max-w-lg max-h-[90vh] overflow-y-auto rounded-[1.5rem] border-white/10 bg-[#16161A]">
        <DialogHeader>
          <DialogTitle className="font-display uppercase text-2xl">{product ? "Modifica prodotto" : "Nuovo prodotto"}</DialogTitle>
          <DialogDescription className="text-zinc-400">I cambiamenti appaiono subito nel menù del sito.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="grid gap-4">
          <label className="text-sm font-semibold">Nome<input required value={f.name} onChange={set("name")} data-testid="product-name-input" className="field mt-1.5" /></label>
          <label className="text-sm font-semibold">Descrizione<textarea rows={2} value={f.description} onChange={set("description")} data-testid="product-description-input" className="field mt-1.5 resize-none" /></label>
          <div className="grid grid-cols-2 gap-3">
            <label className="text-sm font-semibold">Prezzo (€, vuoto = su richiesta)<input inputMode="decimal" value={f.price} onChange={set("price")} data-testid="product-price-input" className="field mt-1.5" placeholder="0,00" /></label>
            <label className="text-sm font-semibold">Categoria
              <select value={f.category} onChange={set("category")} data-testid="product-category-select" className="field mt-1.5">
                {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </label>
          </div>
          <label className="text-sm font-semibold">URL immagine (opzionale)<input value={f.image} onChange={set("image")} data-testid="product-image-input" className="field mt-1.5" placeholder="https://…" /></label>
          <div className="flex flex-wrap gap-6 pt-1">
            <label className="flex items-center gap-3 text-sm font-semibold"><Switch checked={f.available} onCheckedChange={set("available")} data-testid="product-available-switch" /> Disponibile</label>
          </div>
          <button type="submit" disabled={saving} data-testid="product-save-button" className="btn-primary justify-center mt-2 disabled:opacity-60">{saving ? "Salvataggio…" : "Salva"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
